import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-filter-popup',
  templateUrl: './filter-popup.component.html',
  styleUrls: ['./filter-popup.component.scss']
})
export class FilterPopupComponent {
  @Input() items: any[] = [];
  @Input() filterType: string;
  @Input() ui_design_id: number = 0;
  @Input() defaultItemCount: number = 10;
  @Input() defaultLabel: string = 'Pre-orders';
  @Output() togglePopup = new EventEmitter<void>();
  @Output() applyFilter = new EventEmitter<void>();
  @Output() searchAgentEvent = new EventEmitter<string>();

  filteredItems: any[] = [];
  displayedItems: any[] = [];

  ngOnInit() {
    this.filteredItems = [...this.items];
    this.updateDisplayedItems();
  }

  ngOnChanges() {
    this.filteredItems = [...this.items];
    this.updateDisplayedItems();
  }

  onTogglePopup() {
    this.togglePopup.emit();
  }

  onApplyFilter() {
    this.applyFilter.emit();
  }

  onSearch(searchTerm: string) {
    this.searchAgentEvent.emit(searchTerm);
    this.filteredItems = this.items.filter(item =>
      item.selectedNames.toLowerCase().includes(searchTerm.toLowerCase())
    );
    this.updateDisplayedItems();
  }

  updateDisplayedItems() {
    this.displayedItems = this.filteredItems.slice(0, this.defaultItemCount);
  }

  getDisplayItems() {
    return this.displayedItems;
  }

  showMore() {
    this.displayedItems = this.filteredItems;
  }

}
